import React, { useCallback, useEffect, useMemo, useState } from 'react';

import SortItem from './Item';
import SortableItem from './SortableItem';
import SortableList, { Item } from './SortableList';

interface SortableListFormGroupProps<T extends Item = Item> {
    list: T[];
    onUpdated?(items: T[]): void;
    renderSortableItem?(item: T): JSX.Element;
    renderItem?(item: T): JSX.Element;
}

const SortableListFormGroup = <T extends Item>({ list, onUpdated, renderItem, renderSortableItem }: SortableListFormGroupProps<T>) => {
    const [items, setItems] = useState(list);

    useEffect(() => {
        setItems(list);
    }, [list]);

    const onUpdatedHandler = useCallback(onUpdated ? onUpdated : setItems, [onUpdated]);

    const renderSortableItemFunction = useMemo(
        () => (renderSortableItem ? renderSortableItem : ({ id, name }: T) => <SortableItem id={id}>{name}</SortableItem>),
        [renderItem]
    );
    const renderItemFunction = useMemo(() => (renderItem ? renderItem : ({ id, name }: T) => <SortItem id={id}>{name}</SortItem>), [renderItem]);

    return <SortableList items={items} renderSortableItem={renderSortableItemFunction} renderItem={renderItemFunction} onUpdated={onUpdatedHandler} />;
};

export default SortableListFormGroup;
